import ForgotPage from "@auth/components/pages/ForgotPage"
import ResetPage from "@auth/components/pages/ResetPage"
import SigninPage from "@auth/components/pages/SigninPage"
import SignupPage from "@auth/components/pages/SignupPage"
import WelcomePage from "@auth/components/pages/WelcomePage"
import Router from "@services/router"

export default [
    Router.page({ name: "welcome", path: "/welcome", component: WelcomePage }),
    Router.page({ name: "signin", path: "/signin", component: SigninPage }),
    Router.page({ name: "signup", path: "/registration", component: SignupPage }),
    Router.page({ name: "forgot", path: "/forgot", component: ForgotPage }),
    Router.page({ name: "reset", path: "/reset", component: ResetPage })
]